import React from "react";
import { Card, Row, Col, Typography, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { ClockCircleOutlined, TeamOutlined, ArrowRightOutlined } from "@ant-design/icons";
//import "Common/Style/style.scss";
const { Title, Text } = Typography;
const { useToken } = theme;
const BusinessGroupsMain = () => {
  const { token } = useToken();
  const navigate = useNavigate();
  const cardOptions = [
    {
      key: "pending",
      title: "Pending Requests",
      icon: <ClockCircleOutlined />,
      color: token.colorWarning,
      route: "/business-groups/pending",
      description: "Review and approve new business group requests.",
    },
    {
      key: "groups",
      title: "Business Groups",
      icon: <TeamOutlined />,
      color: token.colorPrimary,
      route: "/business-groups/list",
      description: "View and manage all business groups efficiently.",
    },
  ];
  return (
    <Card className="page-card business-groups-container">
      <Title level={3} className="page-title">
        Business Groups
      </Title>
      <Text type="secondary" className="page-subtitle">
        Oversee pending requests and manage all business groups
      </Text>
      <Row gutter={[24, 24]} className="card-grid">
        {cardOptions.map((option) => (
          <Col xs={24} sm={12} md={12} lg={8} key={option.key}>
            <Card
              hoverable
              className="option-card"
              onClick={() => navigate(option.route)}
              style={{ border: `4px solid ${option.color}` }}
            >
              <div className="option-card-content">
                <div
                  className="icon-circle"
                  style={{ backgroundColor: `${option.color}20`, color: option.color }}
                >
                  {option.icon}
                </div>
                <Title level={4} className="option-title">
                  {option.title}
                </Title>
                <Text type="secondary" className="option-description">
                  {option.description}
                </Text>
                <div className="option-link" style={{ color: option.color }}>
                  <Text strong>
                    Go to section <ArrowRightOutlined />
                  </Text>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
};
export default BusinessGroupsMain;
